export const accessToken = (state) => state.app.accessToken;
export const empresaActual = (state) => state.app.empresa;
export const usuarioActual = (state) => state.app.usuario;
export const isSideMenuOpen = (state) => state.app.sideMenuOpen;
export const pedidoActual = (state) => state.app.pedido;

const appSelectors = {
  accessToken,
  empresaActual,
  isSideMenuOpen,
  usuarioActual,
  pedidoActual,
};

export default appSelectors;
